#import "../fragments/inbound-email-rules-fragment.graphql"

query GetInboundEmailRules {
    inboundEmailRules {
        ...InboundEmailRulesFragment
    }
}
